import React from "react"

export function ProfileIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 113.054 126.301">
            <g id="_001-user-1" data-name="001-user-1" transform="translate(-24.165)">
                <g id="Group_2748" data-name="Group 2748" transform="translate(47.908)">
                    <g id="Group_2747" data-name="Group 2747" transform="translate(0)">
                        <path
                            id="Path_651"
                            data-name="Path 651"
                            d="M143.583,0a32.792,32.792,0,1,0,32.792,32.792A32.879,32.879,0,0,0,143.583,0Z"
                            transform="translate(-110.791)"
                        />
                    </g>
                </g>
                <g id="Group_2750" data-name="Group 2750" transform="translate(24.165 67.93)">
                    <g id="Group_2749" data-name="Group 2749" transform="translate(0)">
                        <path
                            id="Path_652"
                            data-name="Path 652"
                            d="M136.977,271.7a30.572,30.572,0,0,0-3.293-6.014,40.76,40.76,0,0,0-28.21-17.757,6.036,6.036,0,0,0-4.153,1,34.954,34.954,0,0,1-41.241,0,5.373,5.373,0,0,0-4.153-1,40.465,40.465,0,0,0-28.21,17.757,35.247,35.247,0,0,0-3.293,6.014,3.045,3.045,0,0,0,.143,2.721,57.126,57.126,0,0,0,3.866,5.728,54.418,54.418,0,0,0,6.587,7.446,85.826,85.826,0,0,0,6.587,5.728,65.3,65.3,0,0,0,77.9,0,62.96,62.96,0,0,0,6.587-5.728,66.127,66.127,0,0,0,6.587-7.446,50.205,50.205,0,0,0,3.866-5.728A2.444,2.444,0,0,0,136.977,271.7Z"
                            transform="translate(-24.165 -247.841)"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
